<template>
    <div class="step-box">
        <step
            titleColor="green"
            otherClass="first-step"
        >
            <p slot="title">Step 1</p>
            <p slot="text">Select a product form</p>
        </step>
        <div class="p-4">
            <div class="flex justify-center">
                <div class="w-4/5 md:flex md:items-center">
                    <div class="md:w-1/3">
                        <label
                            class="pr-4 tracking-wide block text-grey-darker text-xs sm:text-sm md:text-base font-semibold mb-1"
                            for="inline-full-name"
                        >
                            Select Product Form/Concentration
                        </label>
                    </div>
                    <div class="md:w-2/3 flex-shrink">
                        <div class="relative">
                            <select
                                class="shadow appearance-none btn-large w-full bg-white border border-grey-lighter text-grey-darker pr-8 leading-tight focus:outline-none focus:border-grey cursor-pointer"
                                id="grid-state"
                                v-model="productForm"
                                @change="productSelected"
                            >
                                <option>HiPhos 10,000 GT</option>
                                <option>HiPhos 20,000 GT</option>
                                <option>HiPhos 20,000 L</option>
                                <option>HiPhos 50,000 M</option>
                                <option>HiPhos 65,000 L</option>
                            </select>
                            <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
                                <svg
                                    class="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                >
                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="field-label-left is-normal">
                    <label class="label">Select Product Form/Concentration</label>
                </div>
                <div class="field-body">
                    <div class="field is-expanded">
                        <div class="control">
                            <div class="select is-fullwidth">
                                <select
                                    v-model="productForm"
                                    @change="productSelected"
                                >
                                    <option>HiPhos 10.000 GT</option>
                                    <option>HiPhos 20.000 GT</option>
                                    <option>HiPhos 20.000 L</option>
                                    <option>HiPhos 50.000 M</option>
                                    <option>HiPhos 65.000 L</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <div
            class="column is-8 is-offset-2 notification is-danger has-text-centered"
            v-if="showProductError"
        >
            Please select the Product Form that you wish to use
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            productForm: "HiPhos 10,000 GT",
            showProductError: false
        };
    },
    created() {
        EventHub.$on("invalidProduct", () => {
            this.showProductError = true;
        });
    },
    methods: {
        productSelected: function() {
            this.$emit("update:product", this.productForm);
        }
    }
};
</script>
<style type="text/css">
.field-label-left {
    flex: 0 0 50%;
    text-align: left;
}

.card {
    border-radius: 5px;
}
</style>
